import { createContext, useContext, useEffect, useState } from "react";

const TryOnContext = createContext(null);
const STORAGE_KEY = "bkoss-tenue";

export const TryOnProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const toggle = (product) =>
    setItems((cur) =>
      cur.some((i) => i.id === product.id)
        ? cur.filter((i) => i.id !== product.id)
        : [...cur, product].slice(-4)
    );

  const clear = () => setItems([]);

  return <TryOnContext.Provider value={{ items, toggle, clear }}>{children}</TryOnContext.Provider>;
};

export const useTryOn = () => useContext(TryOnContext);